<aside
  #mainSidebar
  class="main-sidebar sidebar-light-primary elevation-4 cus-text"
  style="overflow: visible !important; position: fixed;"
>
  <!-- Brand Logo -->
  <a [routerLink]="['/admin/']" class="brand-link">
    <img
      src="assets/img/unilogo.png"
      alt="Sinh hoạt cộng đồng"
      class="brand-image"
    />
    <span class="brand-text font-weight-light">Sinh hoạt cộng đồng</span>
  </a>
  <div class="sidebar">
    <nav class="mt-2">
      <ul
        class="nav nav-pills nav-sidebar flex-column"
        data-widget="treeview"
        role="menu"
        data-accordion="false"
      >
        <li class="nav-item">
          <a
            (click)="setTitle('sinh-hoat-cong-dong')"
            [routerLink]="['/admin/sinh-hoat-cong-dong']"
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="fas fa-envelope"></i>
            <p>&nbsp; Sinh hoạt cộng đồng</p>
          </a>
        </li>
        <li class="nav-item">
          <a
            (click)="setTitle('thiet-lap')"
            [routerLink]="['/admin/thiet-lap']"
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="fas fa-envelope"></i>
            <p>&nbsp; Thiết lập thời gian nộp</p>
          </a>
        </li>
      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
</aside>
